import { ADMIN, DATASCIENTIST, USER } from 'shared/enums/rolesTypes'

export const VIEW_PROJECTS = 'view_projects'
export const VIEW_PROJECT = 'view_project'
export const CREATE_PROJECT = 'create_project'
export const EDIT_PROJECT = 'edit_project'
export const DELETE_PROJECT = 'delete_project'
export const EDIT_PROJECT_EXPORT = 'edit_project_export'

const ALL_PRIVILEGES = [VIEW_PROJECTS, VIEW_PROJECT, CREATE_PROJECT, EDIT_PROJECT, DELETE_PROJECT, EDIT_PROJECT_EXPORT]

export default ALL_PRIVILEGES

export const USER_PRIVILEGES = [VIEW_PROJECTS, VIEW_PROJECT]
export const DATASCIENTIST_PRIVILEGES = [...USER_PRIVILEGES, CREATE_PROJECT, EDIT_PROJECT_EXPORT]
export const ADMIN_PRIVILEGES = ALL_PRIVILEGES

export const USER_PROJECT_PRIVILEGES = [VIEW_PROJECT]
export const DATASCIENTIST_PROJECT_PRIVILEGES = [...USER_PROJECT_PRIVILEGES, EDIT_PROJECT_EXPORT]
export const ADMIN_PROJECT_PRIVILEGES = [...DATASCIENTIST_PROJECT_PRIVILEGES, EDIT_PROJECT, DELETE_PROJECT]

export const PRIVILEGES = {
  [ADMIN]: ADMIN_PRIVILEGES,
  [DATASCIENTIST]: DATASCIENTIST_PRIVILEGES,
  [USER]: USER_PRIVILEGES,
}

export const PROJECT_PRIVILEGES = {
  [ADMIN]: ADMIN_PROJECT_PRIVILEGES,
  [DATASCIENTIST]: DATASCIENTIST_PROJECT_PRIVILEGES,
  [USER]: USER_PROJECT_PRIVILEGES,
}
